"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldAttrsUtils = require("./fieldAttrsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/label-has-for: 0 */

/* htmlFor (for) is being added to the label with ...labelAttributes */
var FieldLabel = function FieldLabel(_ref) {
  var fieldName = _ref.fieldName,
      label = _ref.label,
      isInvalid = _ref.isInvalid,
      isHidden = _ref.isHidden,
      children = _ref.children;
  return _react.default.createElement("label", (0, _fieldAttrsUtils.labelAttributes)({
    fieldName: fieldName,
    isInvalid: isInvalid,
    isHidden: isHidden
  }), children || label);
};

exports.FieldLabel = FieldLabel;
FieldLabel.defaultProps = {
  isInvalid: false,
  isHidden: false,
  children: null,
  label: null
};
FieldLabel.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  isInvalid: _propTypes.default.bool,
  isHidden: _propTypes.default.bool,
  children: _propTypes.default.node,
  // label is only required if children are not supplied
  label: function label(props, propName, componentName) {
    // eslint-disable-line consistent-return
    if (!props.children && !props[propName]) {
      return new Error("The prop ".concat(propName, " is marked as required in ").concat(componentName, " \n                              when children aren't supplied, but its value is undefined"));
    }
  }
};